import { UserData } from '@pocketoutdoormedia/header-wc';
import { RIVT_ROLES } from 'lib/constants';

export const getSubscriptionName = (
  userRoles: string
): UserData['membership'] => {
  if (
    userRoles.includes(RIVT_ROLES.ActivePassFull) ||
    userRoles.includes(RIVT_ROLES.Oplus)
  ) {
    return 'outside_plus';
  }
  if (userRoles.includes(RIVT_ROLES.OutsideDigital)) {
    return 'outside_digital';
  }

  return 'free';
};
